import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-676c59d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "m-redeemable-tokens"
}
const _hoisted_2 = { class: "m-redeemable-tokens-tabs" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Eligible Tokens ")
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Claimed Tokens ")
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "m-redeemable-tokens-list"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "m-redeemable-tokens-none"
}
const _hoisted_10 = {
  key: 2,
  class: "m-redeemable-tokens-list"
}
const _hoisted_11 = {
  key: 1,
  class: "m-redeemable-tokens-none"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_token = _resolveComponent("m-token")!

  return (_ctx.eligibleTokens.length || _ctx.redeemedTokens.length || _ctx.redeemedTokensByOthers.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: _normalizeClass({ selected: _ctx.showEligibleTab }),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showEligibleTab = true))
          }, [
            _hoisted_3,
            (_ctx.eligibleTokens.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.eligibleTokens.length), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("button", {
            class: _normalizeClass({ selected: !_ctx.showEligibleTab }),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showEligibleTab = false))
          }, [
            _hoisted_5,
            (_ctx.redeemedTokens.length > 0 || _ctx.redeemedTokensByOthers.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.redeemedTokens.length + _ctx.redeemedTokensByOthers.length), 1))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        (_ctx.showEligibleTab && _ctx.eligibleTokens.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_ctx.limitReached)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Limit of " + _toDisplayString(_ctx.state.campaign.redemptionsPerAddress) + " per wallet reached ", 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eligibleTokens, (token, idx) => {
                return (_openBlock(), _createBlock(_component_m_token, {
                  key: idx,
                  token: token,
                  "on-click": _ctx.setActiveEligibleToken,
                  cta: _ctx.limitReached ? '' : _ctx.getClaimText
                }, null, 8, ["token", "on-click", "cta"]))
              }), 128))
            ]))
          : (_ctx.showEligibleTab)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, " You have already redeemed all your tokens! "))
            : _createCommentVNode("", true),
        (!_ctx.showEligibleTab)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.redeemedTokens, (token, idx) => {
                return (_openBlock(), _createBlock(_component_m_token, {
                  key: idx,
                  token: token,
                  "on-click": _ctx.setActiveRedemption,
                  cta: 'Details'
                }, null, 8, ["token", "on-click"]))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.redeemedTokensByOthers, (token, idx) => {
                return (_openBlock(), _createBlock(_component_m_token, {
                  key: idx,
                  token: token,
                  "on-click": () => {},
                  cta: 'Redeemed by Someone Else'
                }, null, 8, ["token", "on-click"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_11, " Sorry, you have no tokens eligible for this campaign! "))
}